<template>
  <Dialog
    :model-value="visible"
    :title="title"
    dialog-type="error"
    dialog-size="small"
    :header-icon-src="deleteDialogIcon"
    :close-on-overlay="!isLoading"
    @update:model-value="(value) => { if (!value) handleClose() }"
    @close="handleClose"
  >
    <div class="delete-dialog" :class="{ 'is-loading': isLoading }">
      <div class="dialog-content">
        <!-- <div v-if="showIcon" class="header-icon">
          <img src="@/assets/MyWorkBench/archive/delete.svg" alt="Delete" />
        </div> -->
        <p :data-testid="`${testIdPrefix}.message-text`" class="dialog-message">
          Are you sure you want to delete <strong>{{ displayItemName }}</strong>? This action cannot be undone.
        </p>
        <p v-if="isLoading" class="loading-text">{{ loadingText }}</p>
      </div>
    </div>

    <template #footer>
      <div class="footer-actions">
        <ResponsiveButton
          :data-testid="`${testIdPrefix}.cancel-btn`"
          button_type="outlined"
          built_in_theme="error"
          size="medium"
          :disabled="isLoading"
          @click-button="handleClose"
        >
          Cancel
        </ResponsiveButton>
        <ResponsiveButton
          :data-testid="`${testIdPrefix}.confirm-btn`"
          button_type="filled"
          built_in_theme="error"
          size="medium"
          :disabled="isLoading"
          @click-button="handleConfirm"
        >
          Delete
        </ResponsiveButton>
      </div>
    </template>
  </Dialog>
</template>

<script>
import deleteDialogIcon from '@/assets/MyWorkBench/archive/delete.svg';


export default {
  name: 'DeleteConfirmDialog',
  props: {
    // Namespace for the dialog's data-testid attributes (domain.component), so each
    // caller's confirm / cancel buttons are addressable in QA tests.
    testIdPrefix: {
      type: String,
      default: 'shared.delete-confirm-dialog'
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Delete',
    },
    itemName: {
      type: String,
      default: '',
    },
    itemType: {
      type: String,
      default: 'item',
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    modalClass: {
      type: String,
      default: 'delete-confirm-dialog',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loadingText: {
      type: String,
      default: 'Deleting...'
    },
    confirmAction: {
      type: Function,
      default: null,
    },
  },
  emits: ['update:modelValue', 'confirm'],
  data() {
    return {
      internalLoading: false,
      deleteDialogIcon,
    };
  },
  computed: {
    visible: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
    displayItemName() {
      return this.itemName || this.itemType;
    },
    isLoading() {
      return this.loading || this.internalLoading;
    },
  },
  methods: {
    handleClose() {
      if (this.isLoading) return;
      this.visible = false;
    },
    async handleConfirm() {
      if (this.isLoading) return;

      if (!this.confirmAction) {
        this.$emit('confirm');
        return;
      }

      this.internalLoading = true;
      try {
        await this.confirmAction();
        this.visible = false;
        this.$emit('confirm');
      } finally {
        this.internalLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.delete-dialog {
  width: 100%;
  height: 100%;
}

.header-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.header-icon img {
  width: 100%;
  height: 100%;
}

.dialog-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f9fbfd;
  padding: 24px 32px;
  text-align: center;
  gap: 12px;
}

.dialog-message {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #374957;
  line-height: 28px;
  margin: 0;
  text-align: center;
}

.dialog-message strong {
  font-weight: 700;
}

.loading-text {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #1e4670;
  line-height: 20px;
  margin: 0;
}

.footer-actions {
  display: flex;
  gap: 12px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.is-loading {
  opacity: 0.85;
}
</style>
